import React, { useEffect, useState, Fragment } from 'react';
import classNames from 'classnames';
import { postAPI_GPT_Query } from '../../../../../../constants/APIs';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import { Button, DropdownItem } from 'reactstrap';
const AutonomousReplies = ({
  propertyId,
  locale,
  messages,
  emailIntegration,
  channelDetails,
  handleMessage,
  conversationId,
}) => {
  const [questionSetData, setQuestionSetData] = useState();
  const [chatHistory, setChatHistory] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (messages !== undefined && messages.length > 0) {
      let history = [];
      messages.map((m) => {
        let text = m.text;
        if (
          text
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace('\r', '')
            .replace('\n', '') !== ''
        ) {
          text = text.replace(/<\/?[^>]+(>|$)/g, '');
          text.replace(/\\n/g, '');
          if (m.source === 'Bot')
            history.push({
              ai: text,
            });
          else
            history.push({
              human: text,
            });
        }
      });
      setChatHistory(history);
    }
  }, [propertyId]);

  const loadQuestionSet = () => {
    if (channelDetails !== undefined && channelDetails?.autonomousReplies) {
      if (
        channelDetails?.autonomousReplies?.assistantEnabled &&
        channelDetails?.autonomousReplies.versionDynamicFlow ===
          '6DynamicConverstionFlow'
      ) {
        if (channelDetails?.autonomousReplies?.assistantId) {
          let url = `${process.env.REACT_APP_CHAT_API}/question-sets`;
          AxiosPublicAPI({
            method: 'get',
            url: `${url}?id=${channelDetails?.autonomousReplies?.assistantId}`,
          }).then((res) => {
            if (res.data?.result) {
              console.log(res.data.result, 65, res.data.result.flowInvokeApi);
              setQuestionSetData(res.data.result);
            }
          });
        }
      }
    }
  };

  useEffect(() => {
    loadQuestionSet();
  }, [propertyId]);

  const handleGenerate = () => {
    let body = {
      groupId: getGroupID(),
      propertyId: 'e655dab2-987b-4683-ad9b-599814b414b6',
      language: locale,
      q: '',
      suffix: channelDetails?.autonomousReplies?.instructions || '',
      conversationId: conversationId,
      propertyName: 'Hotel Grand (CPG)',
      modelName: 'gpt-4o-mini',
      history: chatHistory,
    };
    let queryUrl = `${postAPI_GPT_Query}/query-chatbot`;
    AxiosAPI({
      method: 'post',
      url: `${queryUrl}`,
      data: body,
    }).then((res) => {
      if (res.data.arguments !== undefined && res.data.arguments != null) {
        try {
          let body = JSON.parse(res.data.arguments);
          if (body?.response) {
            let lines = body?.response.split('\\n');
            if (lines.length > 0) {
              let newResponse = lines
                .map((m) => '<p>' + m.trim().replace(/\n/g, '<br />') + '</p>')
                .join('');
              handleMessage('user', newResponse);
            } else {
              handleMessage('user', body.response);
            }
          }
        } catch {}
      }
    });
  };

  const handleGenerateClick = () => {
    setLoading(true);
    if (questionSetData) handleGenerateWithAssistant();
    else handleGenerate();
  };

  const handleGenerateWithAssistant = () => {
    let systemTools = [];
    if (
      questionSetData.flowInvokeApi &&
      questionSetData.flowInvokeApi?.isEnabled
    ) {
      let tools = questionSetData.flowInvokeApi?.json;
      tools.map((obj) =>
        systemTools.push({
          type: 'function',
          function: JSON.parse(obj),
        })
      );
    }
    let body = {
      groupId: getGroupID(),
      propertyId: 'e655dab2-987b-4683-ad9b-599814b414b6',
      language: locale,
      q: '',
      suffix: '',
      conversationId: conversationId,
      propertyName: 'Hotel Grand',
      modelName: 'gpt-4o-mini',
      history: chatHistory,
      systemInstructions: questionSetData.instructions,
      tools: systemTools,
    };
    let queryUrl = `${postAPI_GPT_Query}/query-chatbot-json-system`;
    AxiosAPI({
      method: 'post',
      url: `${queryUrl}`,
      data: body,
    })
      .then((res) => {
        if (res.data.arguments !== undefined && res.data.arguments != null) {
          try {
            let body = JSON.parse(res.data.arguments);
            if (body?.response) {
              let lines = body?.response.split('\\n');
              if (lines.length > 0) {
                let newResponse = lines
                  .map(
                    (m) => '<p>' + m.trim().replace(/\n/g, '<br />') + '</p>'
                  )
                  .join('');
                handleMessage('user', newResponse);
              } else {
                handleMessage('user', body.response);
              }
            }
          } catch {}
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Fragment>
      <div
        onClick={loading ? null : handleGenerateClick}
        className={`quill-footer-button ${loading ? 'loading' : ''}`}
        title="Generate Response"
        style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
      >
        {loading ? (
          <i className="fa fa-spinner fa-spin" />
        ) : (
          <i className="simple-icon-energy"></i>
        )}
      </div>
    </Fragment>
  );
};

export default AutonomousReplies;
